"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridTemplateSingleValueDataType = exports.explicitTrackListDataType = exports.gridTemplateColumnsDataType = exports.gridTemplateRowsDataType = exports.gridTemplateAreasDataType = exports.gridLineEndDataType = exports.gridLineDataType = exports.flexWrapDataType = exports.flexDirectionDataType = exports.flexBasisDataType = exports.flexShrinkDataType = exports.flexGrowDataType = exports.flexSingleValueDataType = exports.justifyItemsDataType = exports.alignItemsDataType = exports.justifyContentDataType = exports.alignContentDataType = exports.fontFamilyDataType = exports.lineHeightDataType = exports.fontSizeDataType = exports.fontStretchDataType = exports.fontWeightDataType = exports.fontVariantDataType = exports.fontStyleDataType = exports.fontSingleValueDataType = exports.backgroundClipDataType = exports.backgroundOriginDataType = exports.boxDataType = exports.attachmentDataType = exports.repeatStyleDataType = exports.bgSizeDataType = exports.bgPositionDataType = exports.imageSourceDataType = exports.imageDataType = exports.gradientDataType = exports.borderImageWidthDataType = exports.borderImageRepeatDataType = exports.borderImageOutsetDataType = exports.borderImageSliceDataType = exports.outlineColorDataType = exports.backgroundColorDataType = exports.colorDataType = exports.lineWidthDataType = exports.outlineStyleDataType = exports.lineStyleDataType = exports.widthDataType = exports.lengthPercentageDataType = exports.lengthDataType = exports.universalDataType = exports.ALWAYS_DATA_TYPE = void 0;
exports.shadowSingleValueDataType = exports.insetDataType = exports.listStyleTypeDataType = exports.listStylePositionDataType = exports.listStyleSingleValueDataType = exports.textDecorationStyleDataType = exports.textDecorationLineDataType = exports.overflowDataType = exports.gridSingleValueDataType = exports.gridAutoColumnsDataType = exports.gridAutoRowsDataType = exports.gridAutoFlowDataType = void 0;
var tslib_1 = require("tslib");
var data_types_consts_1 = require("./data-types-consts");
var data_types_utils_1 = require("./data-types-utils");
var data_types_predicates_1 = require("./data-types-predicates");
var data_types_state_machines_1 = require("./data-types-state-machines");
exports.ALWAYS_DATA_TYPE = {
    dataType: data_types_consts_1.DataTypeType.Unknown,
    predicate: function () { return true; },
    initial: data_types_consts_1.DEFAULT_DIMENSION,
};
// <universal>
// syntax: inherit | initial | unset | revert
exports.universalDataType = (0, data_types_utils_1.createUnorderedListDataType)(data_types_consts_1.DataTypeType.Universal);
// <length>
exports.lengthDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.Length, [data_types_predicates_1.lengthPredicate, data_types_predicates_1.calcPredicate]);
// <length-percentage>
exports.lengthPercentageDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.LengthPercentage, [
    data_types_predicates_1.lengthPercentagePredicate,
    data_types_predicates_1.calcPredicate,
]);
// <width>
exports.widthDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.Width, [
    exports.lengthPercentageDataType.predicate,
    data_types_predicates_1.autoKeywordPredicate,
]);
// <line-style>
// syntax: none | hidden | dotted | dashed | solid | double | groove | ridge | inset | outset
exports.lineStyleDataType = (0, data_types_utils_1.createUnorderedListDataType)(data_types_consts_1.DataTypeType.LineStyle);
// <'outline-style'>
// syntax: auto | <'border-style'>
exports.outlineStyleDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.OutlineStyle, [
    data_types_predicates_1.autoKeywordPredicate,
    exports.lineStyleDataType.predicate,
]);
// <line-width>
// syntax: <length> | thin | medium | thick
exports.lineWidthDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.LineWidth, [
    exports.lengthDataType.predicate,
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.LINE_WIDTH_KEYWORDS),
]);
// <color>
// syntax: <rgb()> | <rgba()> | <hsl()> | <hsla()> | <hex-color> | <named-color> | currentcolor | <deprecated-system-color>
exports.colorDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.Color, [
    (0, data_types_utils_1.functionPredicate)(data_types_consts_1.COLOR_SPACE_FUNCTIONS),
    (0, data_types_utils_1.hexColorPredicate)(),
    (0, data_types_utils_1.hexaColorPredicate)(),
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.COLOR_KEYWORDS),
]);
exports.backgroundColorDataType = tslib_1.__assign(tslib_1.__assign({}, exports.colorDataType), { initial: data_types_consts_1.INITIAL_BACKGROUND_COLOR });
// <'outline-color'>
// syntax: <color> | invert
exports.outlineColorDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.OutlineColor, [
    exports.colorDataType.predicate,
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.OUTLINE_COLOR_INVERT_KEYWORD),
]);
// <border-image-slice>
// syntax: <number-percentage>{1,4} && fill?
exports.borderImageSliceDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.BorderImageSlice, [data_types_predicates_1.borderImageSlicePredicate]);
// <border-image-outset>
// syntax: [ <length> | <number> ]{1,4}
exports.borderImageOutsetDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.BorderImageOutset, [
    (0, data_types_utils_1.curlyBracesPredicate)([exports.lengthDataType.predicate, data_types_predicates_1.numberPredicate], 1, 4),
]);
// <border-image-repeat>
// syntax: [ stretch | repeat | round | space ]{1,2}
exports.borderImageRepeatDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.BorderImageRepeat, [
    (0, data_types_utils_1.curlyBracesPredicate)([(0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.BORDER_IMAGE_REPEAT_MULTIPLE_KEYWORDS)], 1, 2),
]);
// <border-image-width>
// syntax: [ <length-percentage> | <number> | auto ]{1,4}
exports.borderImageWidthDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.BorderImageWidth, [
    (0, data_types_utils_1.curlyBracesPredicate)([exports.lengthPercentageDataType.predicate, data_types_predicates_1.numberPredicate, data_types_predicates_1.autoKeywordPredicate], 1, 4),
]);
// <gradient>
// syntax: <linear-gradient()> | <repeating-linear-gradient()> | <radial-gradient()> | <repeating-radial-gradient()> | <conic-gradient()>
exports.gradientDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.Gradient, [(0, data_types_utils_1.functionPredicate)(data_types_consts_1.GRADIENT_FUNCTIONS)]);
// <image>
// syntax: <url> | <image()> | <image-set()> | <element()> | <paint()> | <cross-fade()> | <gradient>
exports.imageDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.Image, [
    (0, data_types_utils_1.functionPredicate)(data_types_consts_1.IMAGE_FUNCTIONS),
    exports.gradientDataType.predicate,
]);
// <image-source>
// syntax: none | <image>
exports.imageSourceDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.ImageSource, [
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.IMAGE_SOURCE_NONE_KEYWORD),
    exports.imageDataType.predicate,
]);
// <bg-position>
/*
syntax: [
  [ left | center | right | top | bottom | <length-percentage> ] |
  [ left | center | right | <length-percentage> ] [ top | center | bottom | <length-percentage> ] |
  [ center | [ left | right ] <length-percentage>? ]
    && [ center | [ top | bottom] <length-percentage>? ]
]
*/
exports.bgPositionDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.BgPosition, [
    function (ast, index, items) {
        if (ast.type !== 'text' || index === undefined || !items) {
            return false;
        }
        return (0, data_types_state_machines_1.stateMachineDataTypeMatch)(items, index, (0, data_types_state_machines_1.bgPositionStateMachine)(exports.lengthPercentageDataType.predicate));
    },
]);
// <bg-size>
// syntax: [ <length-percentage> | auto ]{1,2} | cover | contain
exports.bgSizeDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.BgSize, [
    (0, data_types_utils_1.curlyBracesPredicate)([exports.lengthPercentageDataType.predicate, data_types_predicates_1.autoKeywordPredicate], 1, 2),
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.BG_SIZE_KEYWORDS),
]);
// <repeat-style>
// syntax: repeat-x | repeat-y | [ repeat | space | round | no-repeat ]{1,2}
exports.repeatStyleDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.RepeatStyle, [
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.REPEAT_STYLE_SINGLE_KEYWORDS),
    (0, data_types_utils_1.curlyBracesPredicate)([(0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.REPEAT_STYLE_MULTIPLE_KEYWORDS)], 1, 2),
]);
// <attachment>
// syntax: scroll | fixed | local
exports.attachmentDataType = (0, data_types_utils_1.createUnorderedListDataType)(data_types_consts_1.DataTypeType.Attachment);
// <box>
// syntax: border-box | padding-box | content-box
exports.boxDataType = (0, data_types_utils_1.createUnorderedListDataType)(data_types_consts_1.DataTypeType.Box);
exports.backgroundOriginDataType = tslib_1.__assign(tslib_1.__assign({}, exports.boxDataType), { initial: data_types_consts_1.INITIAL_BACKGROUND_ORIGIN });
exports.backgroundClipDataType = tslib_1.__assign(tslib_1.__assign({}, exports.boxDataType), { initial: data_types_consts_1.INITIAL_BACKGROUND_CLIP });
// <font>
// syntax: caption | icon | menu | message-box | small-caption | status-bar
exports.fontSingleValueDataType = (0, data_types_utils_1.createUnorderedListDataType)(data_types_consts_1.DataTypeType.Font);
// <font-style>
// syntax: normal | italic | oblique <angle>?
exports.fontStyleDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.FontStyle, [
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.FONT_STYLE_KEYWORDS),
    data_types_predicates_1.fontStylePredicate,
]);
// <font-variant>
// syntax: normal | small-caps
exports.fontVariantDataType = (0, data_types_utils_1.createUnorderedListDataType)(data_types_consts_1.DataTypeType.FontVariant);
// <font-weight>
// syntax: <font-weight-absolute> | <font-weight-relative> | [1,1000]
exports.fontWeightDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.FontWeight, [
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.FONT_WEIGHT_KEYWORDS),
    (0, data_types_utils_1.dimensionPredicate)({
        min: data_types_consts_1.FONT_WEIGHT_NUMBER_RANGE_MIN,
        max: data_types_consts_1.FONT_WEIGHT_NUMBER_RANGE_MAX,
    }),
]);
// <font-stretch>
// syntax: normal | ultra-condensed | extra-condensed | condensed | semi-condensed | semi-expanded | expanded | extra-expanded | ultra-expanded
exports.fontStretchDataType = (0, data_types_utils_1.createUnorderedListDataType)(data_types_consts_1.DataTypeType.FontStretch);
// <font-size>
// syntax: <length-percentage> | <absolute-size> | <relative-size>
exports.fontSizeDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.FontSize, [
    exports.lengthPercentageDataType.predicate,
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.FONT_SIZE_KEYWORDS),
]);
// <line-height>
// syntax: <number> | <length-percentage> | normal
exports.lineHeightDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.LineHeight, [
    data_types_predicates_1.numberPredicate,
    exports.lengthPercentageDataType.predicate,
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.LINE_HEIGHT_KEYWORD),
]);
// <font-family>
// syntax: <generic-family> | <string>
exports.fontFamilyDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.FontFamily, [
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.FONT_FAMILY_GENERIC_KEYWORDS),
    data_types_predicates_1.fontFamilyStringPredicate,
]);
// <align-content>
// syntax: normal | baseline | <content-distribution> | <content-position>
exports.alignContentDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.AlignContent, [
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.ALIGN_CONTENT_KEYWORDS),
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.CONTENT_DISTRIBUTION_KEYWORDS),
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.CONTENT_POSITION_KEYWORDS),
]);
// <justify-content>
// syntax: normal | <content-distribution> | <content-position> | left | right
exports.justifyContentDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.JustifyContent, [
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.JUSTIFY_CONTENT_KEYWORDS),
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.CONTENT_DISTRIBUTION_KEYWORDS),
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.CONTENT_POSITION_KEYWORDS),
]);
// <align-items>
// syntax: normal | stretch | baseline | <self-position>
exports.alignItemsDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.AlignItems, [
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.ALIGN_ITEMS_KEYWORDS),
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.SELF_POSITION_KEYWORDS),
]);
// justify-items
// syntax: normal | stretch | baseline | <self-position> | legacy | left | right | center
exports.justifyItemsDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.JustifyItems, [
    exports.alignItemsDataType.predicate,
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.JUSTIFY_ITEMS_KEYWORDS),
]);
// <'flex'>
// syntax: initial | auto | none
exports.flexSingleValueDataType = (0, data_types_utils_1.createUnorderedListDataType)(data_types_consts_1.DataTypeType.Flex);
// <flex-grow>
// syntax: <number>
exports.flexGrowDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.FlexGrow, [data_types_predicates_1.numberPredicate]);
// <flex-shrink>
// syntax: <number>
exports.flexShrinkDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.FlexShrink, [data_types_predicates_1.numberPredicate]);
// <flex-basis>
// syntax: <width> | content | fill | max-content | min-content | fit-content
exports.flexBasisDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.FlexBasis, [
    exports.widthDataType.predicate,
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.FLEX_BASIS_KEYWORDS),
]);
// <flex-direction>
// syntax: row | row-reverse | column | column-reverse
exports.flexDirectionDataType = (0, data_types_utils_1.createUnorderedListDataType)(data_types_consts_1.DataTypeType.FlexDirection);
// <flex-wrap>
// syntax: nowrap | wrap | wrap-reverse
exports.flexWrapDataType = (0, data_types_utils_1.createUnorderedListDataType)(data_types_consts_1.DataTypeType.FlexWrap);
// <grid-line>
// syntax: auto | <custom-ident> | [ <integer> && <custom-ident>? ] | [ span && [ <integer> || <custom-ident> ] ]
exports.gridLineDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.GridLine, [
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.GRID_LINE_AUTO_KEYWORD),
    data_types_predicates_1.gridLinePredicate,
]);
// <grid-line-end>
// syntax: <grid-line> [ / <grid-line> ]?
exports.gridLineEndDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.GridLineEnd, [exports.gridLineDataType.predicate]);
// <grid-template-areas>
// syntax: none | <string>+
exports.gridTemplateAreasDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.GridTemplateAreas, [
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.INITIAL_GRID_TEMPLATE_AREAS),
    data_types_predicates_1.gridTemplateAreasStringPredicate,
]);
// <grid-template-rows>
// syntax: none | <track-list> | <auto-track-list>
exports.gridTemplateRowsDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.GridTemplateRows, [
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.GRID_TEMPLATE_AXIS_NONE_KEYWORD),
    data_types_predicates_1.autoTrackListPredicate,
    data_types_predicates_1.trackListPredicate,
]);
// <grid-template-columns>
// syntax: none | <track-list> | <auto-track-list>
exports.gridTemplateColumnsDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.GridTemplateColumns, [
    exports.gridTemplateRowsDataType.predicate,
]);
// <explicit-track-list>
// syntax: [ <line-names>? <track-size> ]+ <line-names>?
exports.explicitTrackListDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.ExplicitTrackList, [data_types_predicates_1.explicitTrackListPredicate]);
// <grid-template>
// syntax: none
exports.gridTemplateSingleValueDataType = (0, data_types_utils_1.createUnorderedListDataType)(data_types_consts_1.DataTypeType.GridTemplate);
// <grid-auto-flow>
// syntax: auto-flow && dense?
exports.gridAutoFlowDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.GridAutoFlow, [data_types_predicates_1.gridAutoFlowPredicate]);
// <grid-auto-rows>
// syntax: <track-size>+
exports.gridAutoRowsDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.GridAutoRows, [(0, data_types_utils_1.asteriskPredicate)(data_types_predicates_1.trackSizePredicate)]);
// <grid-auto-columns>
// syntax: <track-size>+
exports.gridAutoColumnsDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.GridAutoColumns, [exports.gridAutoRowsDataType.predicate]);
// <grid>
// syntax: none
exports.gridSingleValueDataType = (0, data_types_utils_1.createUnorderedListDataType)(data_types_consts_1.DataTypeType.Grid);
// <overflow>
// syntax: visible | hidden | clip | scroll | auto
exports.overflowDataType = (0, data_types_utils_1.createUnorderedListDataType)(data_types_consts_1.DataTypeType.Overflow);
// <text-decoration-line>
// syntax: none | [ underline || overline || line-through ]
exports.textDecorationLineDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.TextDecorationLine, [
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.TEXT_DECORATION_LINE_NONE_KEYWORD),
    data_types_predicates_1.textDecorationLinePredicate,
]);
// <text-decoration-style>
// syntax: solid | double | dotted | dashed | wavy
exports.textDecorationStyleDataType = (0, data_types_utils_1.createUnorderedListDataType)(data_types_consts_1.DataTypeType.TextDecorationStyle);
// <list-style>
// syntax: none
exports.listStyleSingleValueDataType = (0, data_types_utils_1.createUnorderedListDataType)(data_types_consts_1.DataTypeType.ListStyle);
// <list-style-position>
// syntax: inside | outside
exports.listStylePositionDataType = (0, data_types_utils_1.createUnorderedListDataType)(data_types_consts_1.DataTypeType.ListStylePosition);
// <list-style-type>
// syntax: <counter-style> | <string> | none
exports.listStyleTypeDataType = (0, data_types_utils_1.createDataType)(data_types_consts_1.DataTypeType.ListStyleType, [
    (0, data_types_utils_1.unorderedListPredicate)(data_types_consts_1.LIST_STYLE_TYPE_KEYWORDS),
    (0, data_types_utils_1.stringPredicate)(),
]);
// <inset>
// syntax: inset
exports.insetDataType = (0, data_types_utils_1.createUnorderedListDataType)(data_types_consts_1.DataTypeType.Inset);
// <shadow>
// syntax: none
exports.shadowSingleValueDataType = (0, data_types_utils_1.createUnorderedListDataType)(data_types_consts_1.DataTypeType.Shadow);
//# sourceMappingURL=data-types.js.map